import * as Config from '../../../../config';
import React from "react";
import { useSelector /*, useDispatch*/ } from "react-redux";
// import { MenuItem } from "react-contextmenu";
import { Content, Item, Portal } from "@radix-ui/react-context-menu";

import IconRename from '../svg/IconRename';
import IconRemove from '../svg/IconRemove';
import IconRedirect from '../svg/IconRedirect';
import IconDuplicate from '../svg/IconDuplicate';

// import { setContextMenu } from "../../../../actions/index";
import usePlaylistMenu from '../../../../hooks/usePlaylistMenu';
import { getContextMenuPortalContainer, rightClickContextMenu } from "../../../../utils/zoomMenu";

const useFullPlaylistMenu = (playlist, draggable = false) => {
  const { id } = playlist;
  const to = `/playlists/${id}`;
  const cover = (playlist.covers) ? playlist.covers : ((playlist.release_images && playlist.release_images.length > 0) ? playlist.release_images : [Config.DEFAULT_IMG]);
  const isConnected = useSelector(state => state.isConnected);
  // const dispatch = useDispatch();

  const {
    match, setHistory,
    availableDrop, opacity, refDrop,
    updateFormPlaylist, deleteFormPlaylist, duplicateFormPlaylist, toStore,
    isDraggingPlaylists, onReorder, dragRef
  } = usePlaylistMenu(playlist, to, isConnected, {}, draggable);

  /*
  // V1 - react-contextmenu
  const setActionsContextMenu = () => { 
    let menu = [
      <MenuItem key={`uPlaylist`} onClick={updateFormPlaylist} data={{ action: 'Updated' }}>
        <div className={'flexRow block-contextmenu-item all-hover-fill'}>
          <IconRename />
          {`Rename playlist`}
        </div>
      </MenuItem>,
      <MenuItem key={`dPlaylist`} onClick={deleteFormPlaylist} data={{ action: 'Deleted' }}>
        <div className={'flexRow block-contextmenu-item'}>
          <IconRemove />
          {`Delete playlist`}
        </div>
      </MenuItem>,
    ];
    if (isConnected) {
      menu.push(
        <MenuItem key={`cPlaylist`} onClick={duplicateFormPlaylist} data={{ action: 'Duplicate' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconDuplicate />
            {`Duplicate playlist`}
          </div>
        </MenuItem>
      );
    }
    if (Config.ACCESS_STORE && isConnected) {
      menu.push(
        <MenuItem key={`toStore`} onClick={toStore} data={{ action: 'To' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconRedirect />
            {`View on ${Config.capAppName()}`}
          </div>
        </MenuItem>
      );
    }
    dispatch(setContextMenu(menu,{className: 'dynamic-menu-playlist-menu'}));
  }
  */

  const showContextMenu = (e) => {
    // setActionsContextMenu();  // V1 - react-contextmenu
    rightClickContextMenu(e); // V2 - Right Click Simulation
  }

  //V1
  const onRightClick = (e) => {
    const el = document.getElementById(`more-ref-${id}`);
    (el) && el.click();
  }

  //V2 - @radix-ui/react-context-menu
  const ContextMenuContent = () => (
    <Portal container={getContextMenuPortalContainer()}>
      <Content className={'dynamic-menu-v2'}>
        <Item onSelect={updateFormPlaylist}>
          <div className={'flexRow block-contextmenu-item-v2 all-hover-fill'}>
            <IconRename />
            {`Rename playlist`}
          </div>
        </Item>
        <Item onSelect={deleteFormPlaylist}>
          <div className={'flexRow block-contextmenu-item-v2'}>
            <IconRemove />
            {`Delete playlist`}
          </div>
        </Item>  
        { (isConnected) && (
          <Item onSelect={duplicateFormPlaylist}>
            <div className={'flexRow block-contextmenu-item-v2 all-hover'}>
              <IconDuplicate />
              {`Duplicate playlist`}
            </div>
          </Item>
        )}
        { (Config.ACCESS_STORE && isConnected) && (
          <Item onSelect={toStore}>
            <div className={'flexRow block-contextmenu-item-v2 all-hover'}>
              <IconRedirect />
              {`View on ${Config.capAppName()}`}
            </div>
          </Item>
        )}
      </Content>
    </Portal>
  )

  return {
    match, setHistory,
    availableDrop, opacity, refDrop,
    updateFormPlaylist, deleteFormPlaylist, duplicateFormPlaylist, toStore,
    id, to, cover, showContextMenu, ContextMenuContent, 
    onRightClick,
    isDraggingPlaylists, onReorder, dragRef
  };
};

export default useFullPlaylistMenu;
